import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Host-owned companion service to @intrasync/yard-management.
 *
 * `ntx-yard-asset-links` records which NTX production run a module yard asset
 * came off (productionScheduleId / salesOrderLineId / structureRef). The module
 * has no such concept; see the API migration 20260825000001 for why this is a
 * separate table rather than columns on `yard_assets`.
 */
export const ntxYardStores: ServiceStoreConfig[] = [
  {
    name: "ntx-yard-asset-links",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
    },
  },
];
